export default "__VITE_PUBLIC_ASSET__9cb04c40__"